import React from "react";
import { Tag, Icon, Popover, Progress } from "antd";

const ColorByStatus = {
  PROCESSADO: "green",
  ERRO: "red",
  PROCESSANDO: "blue"
};

export const TableColumns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    render: text => <span style={{ opacity: 0.5 }}>{text}</span>
  },
  {
    title: "DATA CADASTRO",
    dataIndex: "created_at",
    key: "created_at"
  },
  {
    title: "DATA PROCESSAMENTO",
    dataIndex: "dt_processamento",
    key: "dt_processamento"
  },
  {
    title: "PROGRESSO",
    dataIndex: "progress",
    key: "progress",
    render: ([total, processed, error]) => {
      const percent = (processed / total) * 100;
      const success = ((processed - error) / total) * 100;

      return (
        <Progress
          percent={percent}
          successPercent={success}
          strokeColor="#fc8077"
        />
      );
    }
  },
  {
    title: "TOTAL",
    dataIndex: "total",
    key: "total",
    render: value => (
      <span>
        <b>{value} parcelas</b>
      </span>
    )
  },
  {
    title: "STATUS",
    dataIndex: "status",
    key: "status",
    render: ([status, erro]) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Tag color={ColorByStatus[status]}>{status}</Tag>
        {erro && (
          <Popover content={erro}>
            <Icon type="info-circle" style={{ color: "red" }} />
          </Popover>
        )}
      </div>
    )
  },
  {
    title: "RESULTADO",
    dataIndex: "saida",
    key: "saida",
    render: ([totalSuccess, totalErrors]) => (
      <div style={{ display: "flex", gap: "10px" }}>
        <Tag color="green">
          <Icon type="check-circle" />
          &nbsp;
          <span>{totalSuccess}</span>
        </Tag>
        <Tag color="red">
          <Icon type="close-circle" />
          &nbsp;
          <span>{totalErrors}</span>
        </Tag>
      </div>
    )
  }
];



// WEBPACK FOOTER //
// ./src/pages/Acordos/AtualizarParcelasLote/columns.js